import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["body"];
  static values = {
    config: String
  }

  initialize() {
    this._selectRandomTargets();
    this._assignAdConfigToTarget();
  }

  _selectRandomTargets() {
    const randomIndex = Math.floor(Math.random() * this.bodyTargets.length);
    this.selectedTarget = this.bodyTargets[randomIndex];
  }

  _assignAdConfigToTarget() {
    const config = JSON.parse(this.configValue);
    Object.entries(config).forEach(([key, value]) => {
      this.selectedTarget.dataset[key] = value;
    });
  }
}
